import { render } from "./latestBids.vue?vue&type=template&id=24113eee&scoped=true"
import script from "./latestBids.vue?vue&type=script&lang=js"
export * from "./latestBids.vue?vue&type=script&lang=js"

import "./latestBids.vue?vue&type=style&index=0&id=24113eee&scoped=true&lang=css"
import "./latestBids.vue?vue&type=style&index=1&id=24113eee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24113eee"]])

export default __exports__